// AdGenie AI MVP – Generate Ad Copy Variants for Beauty Clinics

import React, { useState, useEffect } from 'react';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Button } from '../../components/ui/button';
import { Loader2, Megaphone } from 'lucide-react';
import AppShell from '../../components/AppShell';
import { useTranslation } from 'react-i18next';

const API = process.env.REACT_APP_API_BASE;

export default function AdGenieSalons() {
  const { t } = useTranslation();
  const [offer, setOffer] = useState('');
  const [tone, setTone] = useState('Friendly');
  const [platform, setPlatform] = useState('Instagram');
  const [language, setLanguage] = useState('English');
  const [occasion, setOccasion] = useState('None');
  const [loading, setLoading] = useState(false);
  const [output, setOutput] = useState('');

  useEffect(() => {
    document.title = t('Ad Genie (Beauty)') + " - Ennoverse";
  }, []);

  const handleGenerate = async () => {
    setLoading(true);
    setOutput('');

    try {
      const response = await fetch(`${API}/api/adgeniesalons/generate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ offer, tone, platform, language, occasion })
      });

      const data = await response.json();
      setOutput(data.ads);
    } catch (error) {
      setOutput(t('error_generate'));
    }

    setLoading(false);
  };

  return (
    <AppShell>
      <div className="col-span-12 text-center space-y-1">
        <div className="max-w-3xl mx-auto p-6">
          <h1 className="text-2xl font-bold mb-4 flex items-center justify-center gap-2">
            <Megaphone className="w-6 h-6" /> {t('Ad Genie (Beauty)')}
          </h1>
          <p className="text-muted-foreground mb-6">{t('adgenie_subtitle')}</p>

          <div className="space-y-4 text-left">
            <label className="block text-sm font-medium">{t('enter_offer')}</label>
            <Input
              placeholder={t('enter_offer')}
              value={offer}
              onChange={(e) => setOffer(e.target.value)}
            />

            <div className="flex flex-col sm:flex-row gap-4">
              <div className="w-full">
                <label className="block text-sm font-medium mb-1">{t('tone')}</label>
                <select className="w-full border rounded p-2" value={tone} onChange={(e) => setTone(e.target.value)}>
                  <option value="Friendly">{t('friendly')}</option>
                  <option value="Luxury">{t('luxury')}</option>
                  <option value="Urgent">{t('urgent')}</option>
                  <option value="Witty">{t('witty')}</option>
                </select>
              </div>

              <div className="w-full">
                <label className="block text-sm font-medium mb-1">{t('platform')}</label>
                <select className="w-full border rounded p-2" value={platform} onChange={(e) => setPlatform(e.target.value)}>
                  <option value="Instagram">Instagram</option>
                  <option value="Facebook">Facebook</option>
                  <option value="Google">Google</option>
                  <option value="Flyer">Flyer</option>
                </select>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <div className="w-full">
                <label className="block text-sm font-medium mb-1">{t('language')}</label>
                <select className="w-full border rounded p-2" value={language} onChange={(e) => setLanguage(e.target.value)}>
                  <option value="English">English</option>
                  <option value="Hindi">Hindi</option>
                  <option value="Arabic">Arabic</option>
                </select>
              </div>

              <div className="w-full">
                <label className="block text-sm font-medium mb-1">{t('occasion')}</label>
                <select className="w-full border rounded p-2" value={occasion} onChange={(e) => setOccasion(e.target.value)}>
                  <option value="None">{t('none')}</option>
                  <option value="Eid">Eid</option>
                  <option value="Weekend">Weekend</option>
                  <option value="New Customer">{t('new_customer')}</option>
                </select>
              </div>
            </div>

            <Button onClick={handleGenerate} disabled={loading || !offer}>
              {loading ? <Loader2 className="animate-spin w-4 h-4 mr-2" /> : t('generate_ads')}
            </Button>

            {output && (
              <Textarea
                className="mt-4 whitespace-pre-wrap text-left"
                rows={10}
                value={output}
                readOnly
              />
            )}
          </div>
        </div>
      </div>
    </AppShell>
  );
}
